/* Shows free or paid shipping, and the matching cart total, based on the visitor's Intelligems test group.
   The server-rendered values stay in place if Intelligems never loads or the visitor isn't in the test. */
if (!customElements.get("ig-shipping-total")) {
  class IgShippingTotal extends HTMLElement {
    connectedCallback() {
      if (!this.dataset.testId) return;

      this.waitForIntelligems()
        .then((igData) => this.update(igData.user.getTestGroup(this.dataset.testId)))
        .catch(() => {});
    }

    waitForIntelligems(timeout = 5000, interval = 100) {
      return new Promise((resolve, reject) => {
        const start = Date.now();
        const check = () => {
          if (typeof window.igData?.user?.getTestGroup === "function") return resolve(window.igData);
          if (Date.now() - start >= timeout || !this.isConnected) return reject();
          setTimeout(check, interval);
        };
        check();
      });
    }

    update(testGroup) {
      if (!testGroup) return;

      const threshold = Number(testGroup.freeShippingThreshold);
      const rate = Number(testGroup.shippingRate);
      if (Number.isNaN(threshold) || Number.isNaN(rate)) return;

      const cartTotal = Number(this.dataset.cartTotal);
      const shippingCost = Math.round(rate * 100);
      const isFree = cartTotal >= threshold * 100 || shippingCost === 0;

      const shippingAmount = this.querySelector("[data-ig-shipping-amount]");
      const totalAmount = this.querySelector("[data-ig-total-amount]");

      if (shippingAmount) shippingAmount.textContent = this.formatMoney(shippingCost);
      if (totalAmount) totalAmount.textContent = this.formatMoney(cartTotal + (isFree ? 0 : shippingCost));

      this.querySelector("[data-ig-shipping-paid]")?.toggleAttribute("hidden", isFree);
      this.querySelector("[data-ig-shipping-free]")?.toggleAttribute("hidden", !isFree);
    }

    /* Formats cents using the shop's money format, e.g. "${{amount}}" or "${{amount}} AUD". */
    formatMoney(cents) {
      const format = (this.dataset.moneyFormat || "${{amount}}").replace(/<[^>]*>/g, "");
      const withDelimiters = (decimals, thousands, decimal) => {
        const [whole, fraction] = (cents / 100).toFixed(decimals).split(".");
        return whole.replace(/\B(?=(\d{3})+(?!\d))/g, thousands) + (fraction ? decimal + fraction : "");
      };

      return format.replace(/\{\{\s*(\w+)\s*\}\}/, (match, placeholder) => {
        switch (placeholder) {
          case "amount_no_decimals":
            return withDelimiters(0, ",", ".");
          case "amount_with_comma_separator":
            return withDelimiters(2, ".", ",");
          case "amount_no_decimals_with_comma_separator":
            return withDelimiters(0, ".", ",");
          default:
            return withDelimiters(2, ",", ".");
        }
      });
    }
  }

  customElements.define("ig-shipping-total", IgShippingTotal);
}
